import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";
import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";

const insights: Array<Insight> = [
    {
        id: "20261009-kalender",
        datum: "09.10.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Kalender-Abos für Veranstaltungen, Material & Verfügbarkeit",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "Kalender aus HiOrg-Server lassen sich jetzt noch flexibler nutzen: Unter „Mein Konto > Kalender-Abos“"
            + " könnt ihr eigene Kalender zusammenstellen und anschließend in anderen Programmen, auf Webseiten oder"
            + " auf einem Bildschirm anzeigen.<br>"
            + "✨ NEU: Ihr könnt auch Belegungen von Fahrzeugen, Räumen und anderem Material als Kalender"
            + " bereitstellen, was die Übersicht über Verfügbarkeiten (bspw. Raumplanung bei Kursen) erleichtert."
            + " Außerdem lassen sich Kalender flexibler konfigurieren und bspw. unterbesetzte Dienste mit anderen"
            + " Gliederungen teilen.",
            "⚠️ Wichtig: Nach dem 31.03.2027 sind nur noch die neuen Abo-Links gültig. Bitte stellt bis dahin eure"
            + " Verfügbarkeitssansichten und iCal-Abos auf die neuen Kalender-Abos um.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/?p=11667",
            },
        ],
    },
];

export {
    insights,
};
